import { action, computed, observable, runInAction } from 'mobx';

import { history } from '../..';
import agent from '../api/agent';
import { IClerk, IClerkFormValues } from '../models/clerk';
import { RootStore } from './rootStore';

export default class ClerkStore {
  rootStore: RootStore;
  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
  }

  @observable clerk: IClerk | null = null;
  @observable loading = false;

  @computed get isSignIn() {
    return !!this.clerk;
  }

  @action signin = async (values: IClerkFormValues) => {
    try {
      const clerk = await agent.Auth.signin(values);
      runInAction(() => {
        this.clerk = clerk;
      });
      this.rootStore.commonStore.setToken(clerk.token);
      history.push('/admin/depositsales');
    } catch (error) {
      throw error;
    }
  };

  @action signout = () => {
    this.rootStore.commonStore.setToken(null);
    this.clerk = null;
    history.push('/admin');
  };

  @action getClerk = async () => {
    try {
      const clerk = await agent.Auth.current();
      runInAction(() => {
        this.clerk = clerk;
      });
    } catch (error) {
      console.log(error);
    }
  };
}
